import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserHistory } from 'history';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { App as AntdApp } from 'antd';

import reducers from './redux/reducers';
import sagas from './redux/sagas';
import Localization from './localization';
import Router from './router';


//  Create history
const history = createBrowserHistory();

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: reducers(history),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore non-serializable values in menu items (React elements in labels and icons)
        // Menu items contain React elements which are not serializable but are safe to store
        ignoredActions: ['menu/SET_STATE'],
        ignoredActionPaths: ['payload.menuData'],
        ignoredPaths: ['menu.menuData'],
      },
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(sagas);


// Modern React 18 rendering
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <AntdApp>
      <Localization>
        <Router history={history} onAppMounted={() => {
        const splash = document.getElementById('app_splash');
        if (splash) {
          splash.classList.add('complete');
          setTimeout(() => {
            splash.classList.add('hidden');
            setTimeout(() => splash.remove(), 220);
          }, 350);
        }
      }} />
      </Localization>
    </AntdApp>
  </Provider>
);

//  Export Store & History
export { store, history };
